import type { GetAllCardsResponse, LoginResponse } from '@shared/api';

const REMEMBER_PASS = 'rememberedPass';
const STUFF = 'stuff';
const SELECTED_CARD_INDEX = 'selectedCardIndex';
const SELECTED_CARD = 'selectedCard';

export class LocalStorageUtils {
  static getRememberMe = (): { userName: string; password: string } | null => {
    const data = localStorage.getItem(REMEMBER_PASS);
    return data ? JSON.parse(data) : null;
  };
  static setRememberMe = (data: { userName: string; password: string }) => localStorage.setItem(REMEMBER_PASS, JSON.stringify(data));
  static removeRememberMe = () => localStorage.removeItem(REMEMBER_PASS);

  static getStuff = () => {
    const data = localStorage.getItem(STUFF);
    return data ? JSON.parse(data) : null;
  };
  static setStuff = (data: LoginResponse) => localStorage.setItem(STUFF, JSON.stringify(data));
  static removeStuff = () => localStorage.removeItem(STUFF);

  static getSelectedCardIndex = () => localStorage.getItem(SELECTED_CARD_INDEX);
  static setSelectedCardIndex = (index: number) => localStorage.setItem(SELECTED_CARD_INDEX, index.toString());

  static getSelectedCard = (): GetAllCardsResponse | null => {
    const data = localStorage.getItem(SELECTED_CARD);
    return data ? JSON.parse(data) : null;
  };
  static setSelectedCard = (data: GetAllCardsResponse) => localStorage.setItem(SELECTED_CARD, JSON.stringify(data));
}
